'use client'

import { FC } from 'react'
import { Inter } from 'next/font/google'

const inter = Inter({ subsets: ['latin'] })

export const FontLayer: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="font-medium antialiased">
      <style jsx global>{`
        html {
          font-family: ${inter.style.fontFamily};
        }
      `}</style>
      {children}
    </div>
  )
}
